import { useQuery, type UseQueryResult } from '@zg-rentals/react-query5';
import {
  getClient,
  RentalManagerUserFreemiumWebApiHandler_charge,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  DatarouterError,
  FreemiumChargeResponseWebDto,
  ListingAlias,
  RentalManagerPaymentProductType,
} from '@zg-rentals/rental-manager-env';

type UseChargeParams = {
  hostApp?: string;
  listingAlias: ListingAlias;
  productType: RentalManagerPaymentProductType;
};

const useCharge = (queryParams: UseChargeParams): UseQueryResult<FreemiumChargeResponseWebDto, DatarouterError> => {
  const { listingAlias, productType, hostApp } = queryParams;

  const queryFn = () =>
    RentalManagerUserFreemiumWebApiHandler_charge(
      { listingAlias, productType, hostApp },
      getClient()?.extend({ timeout: 5 * 60 * 1000 }),
    );

  const queryHook = useQuery<FreemiumChargeResponseWebDto, DatarouterError>({
    queryKey: ['useCharge', listingAlias],
    queryFn,
    enabled: false,
    staleTime: 0,
    retry: 0,
  });

  return queryHook;
};

export { useCharge };
